module.exports = __webpack_public_path__ + "static/media/reglamento_residencia_medica.8fa19836.jpg";